import { sbaAxios } from "../utils/sbaAxios";
import { getTreeofFamilyClientStatements, getPortfoliosByFamily, getLinkedPortfolioAPI } from "../../config/apiConfig";
import {
  FETCH_PORTFOLIOTREEOFFAMILYCS_FAILURE,
  FETCH_PORTFOLIOTREEOFFAMILYCS_SUCCESS,
  FETCH_PORTFOLIOTREEOFFAMILYCS_BEGIN,
  FETCH_PORTFOLIOFAMILY_BEGIN,
  FETCH_PORTFOLIOFAMILY_SUCCESS,
  FETCH_PORTFOLIOFAMILY_FAILURE,
  FETCH_PORTFOLIOCS_BEGIN,
  FETCH_PORTFOLIOCS_SUCCESS,
  FETCH_PORTFOLIOCS_FAILURE,
} from "../constants/portfolioAttribution";

export const getTreeofFamilyCSAction = (searchText) => {
  return (dispatch) => {
    dispatch(fetchPortfolioTreeofFamilyCSBegin());
    sbaAxios({
      url: `${getTreeofFamilyClientStatements}?searchText=${searchText}`,
      method: "get",
    })
      .then((repos) => {
        const TreeofFamilyCS = repos;
        dispatch(fetchPortfolioTreeofFamilyCSSuccess(TreeofFamilyCS));
        return TreeofFamilyCS;
      })
      .catch((error) => dispatch(fetchPortfolioTreeofFamilyCSFailure(error)));
  };
};

export const fetchPortfolioTreeofFamilyCSBegin = () => ({
  type: FETCH_PORTFOLIOTREEOFFAMILYCS_BEGIN,
});

export const fetchPortfolioTreeofFamilyCSSuccess = (TreeofFamilyCS) => ({
  type: FETCH_PORTFOLIOTREEOFFAMILYCS_SUCCESS,
  payload: { TreeofFamilyCS },
});

export const fetchPortfolioTreeofFamilyCSFailure = (errorMessage) => ({
  type: FETCH_PORTFOLIOTREEOFFAMILYCS_FAILURE,
  payload: { errorMessage },
});

export const getFamilyAction = (familyId) => {
  return (dispatch) => {
    dispatch(fetchPortfolioFamilyBegin());
    sbaAxios({
      url: `${getPortfoliosByFamily}?familyId=${familyId}`,
      method: "get",
    })
      .then((repos) => {
        const PortfolioFamily = repos;
        dispatch(fetchPortfolioFamilySuccess(PortfolioFamily));
        return PortfolioFamily;
      })
      .catch((error) => dispatch(fetchPortfolioFamilyFailure(error)));
  };
};

export const fetchPortfolioFamilyBegin = () => ({
  type: FETCH_PORTFOLIOFAMILY_BEGIN,
});

export const fetchPortfolioFamilySuccess = (PortfolioFamily) => ({
  type: FETCH_PORTFOLIOFAMILY_SUCCESS,
  payload: { PortfolioFamily },
});

export const fetchPortfolioFamilyFailure = (errorMessage) => ({
  type: FETCH_PORTFOLIOFAMILY_FAILURE,
  payload: { errorMessage },
});

export const getCSMappingsAction = (clientStatementId ) => {
  return (dispatch) => {
    dispatch(fetchPortfolioCSMappingsBegin());
    sbaAxios({
      url: `${getLinkedPortfolioAPI}${clientStatementId }`,
      method: "get",
    })
      .then((repos) => {
        const CSMappingsData = repos;
        dispatch(fetchPortfolioCSMappingsSuccess(CSMappingsData));
        return CSMappingsData;
      })
      .catch((error) => dispatch(fetchPortfolioFamilyFailure(error)));
  };
};

export const fetchPortfolioCSMappingsBegin = () => ({
  type: FETCH_PORTFOLIOCS_BEGIN,
});

export const fetchPortfolioCSMappingsSuccess = (CSMappingsData) => ({
  type: FETCH_PORTFOLIOCS_SUCCESS,
  payload: { CSMappingsData },
});

export const fetchPortfolioCSMappingsFailure = (errorMessage) => ({
  type: FETCH_PORTFOLIOCS_FAILURE,
  payload: { errorMessage },
});